import Login from "../Login/Login";
import { Navigate, Route, Routes } from "react-router-dom";
import AdminLayout from "../Router/AdminLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import AuthorListing from "../pages/Author/AuthorListing";
import Category from "../pages/category/Category";
import Tags from "../pages/tags/Tags";
import BlogListing from "../pages/blogs/BlogListing";
import AddBlog from "../pages/blogs/AddBlog";
import EditBlog from "../pages/blogs/EditBlog";
import Contact from "../pages/Contact/Contact";
import ScheduleVisit from "../pages/ScheduleVisit/ScheduleVisit";
import Career from "../pages/Career/Career";
import ApplyNow from "../pages/ApplyNow/ApplyNow";
import SeoListing from "../pages/Seo/SeoListing";
import SeoCreate from "../pages/Seo/SeoCreate";
import SeoEdit from "../pages/Seo/SeoEdit";
import NewsListing from "../pages/News/NewsListing";
import NewsCreate from "../pages/News/NewsCreate";
import NewsEdit from "../pages/News/NewsEdit";
import BranchListing from "../pages/Branch/BranchListing";
import BranchAdd from "../pages/Branch/BranchAdd";
import BranchEdit from "../pages/Branch/BranchEdit";
import PermissionDenied from "../pages/permissionDenied/PermissionDenied";
import DynamicPage from "../pages/dynamicPage/DynamicPage";
import AddDynamicPage from "../pages/dynamicPage/AddDynamicPage";
import EditDynamicPage from "../pages/dynamicPage/EditDynamicPage";
import DisclosureListing from "../pages/Disclosure/DisclosureListing";
import DisclosureAdd from "../pages/Disclosure/DisclosureAdd";
import DisclosureEdit from "../pages/Disclosure/DisclosureEdit";
import FaqListing from "../pages/Faq/FaqListing";
import AddFaq from "../pages/Faq/AddFaq";
import EditFaq from "../pages/Faq/EditFaq";
import SitemapEditor from "../pages/Sitemap/SitemapEditor";
import SchemaManagement from "../pages/schema-management/SchemaManagement";
import LlmsManagement from "../pages/Llms/LlmsManagement";
import RobotsManagement from "../pages/Robots/RobotsManagement";
import EmailManagement from "../pages/EmailManagement/EmailManagement";
import AddEmailManagement from "../pages/EmailManagement/AddEmailManagement";
import EditEmailManagement from "../pages/EmailManagement/EditEmailManagement";
import Users from "../pages/Rbac/Users";
import Roles from "../pages/Rbac/Roles";
import Permissions from "../pages/Rbac/Permissions";


export default function Router() {
  return (
    <>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="author" element={<AuthorListing />} />
          <Route path="category" element={<Category />} />
          <Route path="tag" element={<Tags />} />
          <Route path="blog" element={<BlogListing />} />
          <Route path="add-blog" element={<AddBlog />} />
          <Route path="edit-blog/:blog_id" element={<EditBlog />} />
          <Route path="news" element={<NewsListing />} />
          <Route path="add-news" element={<NewsCreate />} />
          <Route path="edit-news/:news_id" element={<NewsEdit />} />
          <Route path="branch" element={<BranchListing />} />
          <Route path="add-branch" element={<BranchAdd />} />
          <Route path="edit-branch/:branch_id" element={<BranchEdit />} />
          <Route path="dynamic-page" element={<DynamicPage />} />
          <Route path="add-dynamic-page" element={<AddDynamicPage />} />
          <Route path="edit-dynamic-page/:dynamic_page_id" element={<EditDynamicPage />} />
          <Route path="contact" element={<Contact />} />
          <Route path="seo" element={<SeoListing />} />
          <Route path="add-seo" element={<SeoCreate />} />
          <Route path="edit-seo/:seo_id" element={<SeoEdit />} />
          <Route path="global-seo" element={<SchemaManagement />} />
          <Route path="schema-management" element={<Navigate to="/global-seo" replace />} />
          <Route path="sitemap" element={<SitemapEditor />} />
          <Route path="llms" element={<LlmsManagement />} />
          <Route path="robots" element={<RobotsManagement />} />
          <Route path="email-management" element={<EmailManagement />} />
          <Route path="add-email-management" element={<AddEmailManagement />} />
          <Route path="edit-email-management/:dynamicemail_id" element={<EditEmailManagement />} />
          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="permissions" element={<Permissions />} />
          <Route path="disclosure" element={<DisclosureListing />} />
          <Route path="add-disclosure" element={<DisclosureAdd />} />
          <Route path="edit-disclosure/:disclosure_id" element={<DisclosureEdit />} />
          <Route path="faq" element={<FaqListing />} />
          <Route path="add-faq" element={<AddFaq />} />
          <Route path="edit-faq/:faq_id" element={<EditFaq />} />
          <Route path="schedule-visit" element={<ScheduleVisit />} />
          <Route path="apply-now" element={<ApplyNow />} />
          <Route path="career" element={<Career />} />
          <Route path="*" element={<PermissionDenied />} />
        </Route>
      </Routes>
    </>
  )
}
